export default __webpack_public_path__ + "static/media/phpmyadmin-icon.de302eb6.svg";